import Ride from "./ride";

export default  Ride;
